{
  "metrics": {
    "totalCustomers": "Total Customers",
    "thisMonth": "this month",
    "weeklyActive": "Weekly Active",
    "monthlyActive": "Monthly Active",
    "ofTotalCustomers": "{{percent}}% of total customers"
  }
}
